export default function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-format/src/formatNumerals.js
// module id = R4S1
// module chunks = 0